import type { BoxProps, ImageProps } from '@hover/blueprint';
import React from 'react';

import { CobrandedLogo } from 'src/shared/components/NavBar/CobrandedLogo';

import { DesignerPartner } from '../../constants/partners';
import { useHomeownerAppContext } from '../../hooks';
import { usePartnerCobranding } from '../../hooks/usePartner';

enum LOGO_FILTER {
  TEXT = 'text',
  TRANSPARENT = 'transparent',
  PILL = 'pill',
}

interface CobrandLogoProps extends BoxProps {
  hideHoverMark?: boolean;
  hideSelfCobranding?: boolean;
  colorMode?: 'light' | 'dark';
  height?: number;
  imageProps?: Partial<ImageProps>;
}

export const CobrandLogo = ({
  hideHoverMark,
  colorMode = 'light',
  height = 200,
  hideSelfCobranding = false,
  ...props
}: CobrandLogoProps) => {
  const cobranding = usePartnerCobranding();
  const homeownerAppContext = useHomeownerAppContext();
  const userOrgId = homeownerAppContext?.user?.orgs?.[0]?.id;
  // hide self cobranding is to not show the cobranding if the cobranding is your
  // own org
  const hideCobranding =
    hideSelfCobranding && userOrgId && userOrgId === cobranding?.orgId;

  let displayType = null;

  if (
    cobranding?.partner !== DesignerPartner.NONE &&
    cobranding?.logoUrl &&
    cobranding?.logoUrlInvert
  ) {
    displayType = LOGO_FILTER.TRANSPARENT;
  } else if (cobranding?.logoUrl) {
    displayType = LOGO_FILTER.PILL;
  } else if (cobranding?.displayName) {
    displayType = LOGO_FILTER.TEXT;
  }

  const cobrandForLogo = hideCobranding
    ? {}
    : {
        logoUrl: cobranding?.logoUrl,
        logoUrlInvert: cobranding?.logoUrlInvert,
        displayName: cobranding?.displayName,
      };

  return (
    <CobrandedLogo
      cobranding={cobrandForLogo}
      colorMode={colorMode}
      height={height}
      hideHoverMark={hideHoverMark}
      variant={displayType ?? undefined}
      {...props}
    />
  );
};
